import { render, staticRenderFns } from "./inboundOrder.vue?vue&type=template&id=0e9c1ce2&scoped=true&"
import script from "./inboundOrder.vue?vue&type=script&lang=ts&"
export * from "./inboundOrder.vue?vue&type=script&lang=ts&"
import style0 from "./inboundOrder.vue?vue&type=style&index=0&id=0e9c1ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9c1ce2",
  null
  
)

export default component.exports